import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=89b3534c&scoped=true&"
import script from "./ModalLayout.vue?vue&type=script&lang=js&"
export * from "./ModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=89b3534c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b3534c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89b3534c')) {
      api.createRecord('89b3534c', component.options)
    } else {
      api.reload('89b3534c', component.options)
    }
    module.hot.accept("./ModalLayout.vue?vue&type=template&id=89b3534c&scoped=true&", function () {
      api.rerender('89b3534c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/mobile/core/ModalLayout.vue"
export default component.exports